import {
  CONTACT_US_HEADER,
  CEASED_TRADING_TOP_TEXT,
  CONTACT_US_TOP_TEXT_CLS_VUL,
} from "components/AppendixScreen/HardStops.const";
import { ErrorType } from "domain/error";

export const handleHardstopTopText = (type: ErrorType) => {
  switch (type) {
    case ErrorType.ClsVulnerable:
      return CONTACT_US_TOP_TEXT_CLS_VUL;
    case ErrorType.ClsCeasedTrading:
      return CEASED_TRADING_TOP_TEXT;
    default:
      return "";
  }
};

export const handleHardstopHeaderText = (type: ErrorType) => {
  switch (type) {
    case ErrorType.ClsVulnerable:
    case ErrorType.ClsCeasedTrading:
      return CONTACT_US_HEADER;
    default:
      return "";
  }
};
